// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1JmC0","file":"styles_file__18odb"};